module.exports = __webpack_public_path__ + "img/20191210161741015.c38e15d8.jpg";